'use client';

/**
 * Tabs Container Component
 *
 * Renders an interactive tabs interface.
 */

import classNames from 'classnames';
import React, { useState } from 'react';

import type { TabsConfig } from '../types';

interface TabsContainerProps {
  config: TabsConfig;
  className?: string;
}

export const TabsContainer: React.FC<TabsContainerProps> = ({ config, className }) => {
  const [activeTab, setActiveTab] = useState(config.defaultTab);

  return (
    <div className={classNames('tabs-container', className)}>
      {/* Tab Navigation */}
      <div className="tabs-nav flex border-b border-gray-200 mb-4">
        {config.tabs.map((tab) => (
          <button
            key={tab.index}
            onClick={() => setActiveTab(tab.index)}
            className={classNames(
              'px-4 py-2 font-medium transition-colors',
              activeTab === tab.index
                ? 'border-b-2 border-[#F7931E] text-[#F7931E]'
                : 'text-gray-600 hover:text-gray-800',
            )}
            dangerouslySetInnerHTML={{ __html: tab.triggerHtml }}
          />
        ))}
      </div>

      {/* Tab Content */}
      <div className="tabs-content">
        {config.tabs.map((tab) => (
          <div
            key={tab.index}
            className={classNames('tab-pane', {
              hidden: activeTab !== tab.index,
              block: activeTab === tab.index,
            })}
            dangerouslySetInnerHTML={{ __html: tab.contentHtml }}
          />
        ))}
      </div>
    </div>
  );
};
